<div class="column-picker">
  @if (openedBy === 'button') {
    <button [matMenuTriggerFor]="rootMenu" mat-stroked-button>Add column</button>
  } @else {
    <mat-form-field class="column-picker__form-field">
      <mat-select [formControl]="fakeControl" style="display: none"></mat-select>
      <div
        tabindex="0"
        class="column-picker__trigger"
        (keydown.enter)="menuTrigger.openMenu()"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="rootMenu">
        <span class="column-picker__trigger--value"
          >{{ columnName || 'Select Column' }}{{ required && !columnName ? '*' : '' }}</span
        >
        <span class="material-symbols-outlined">arrow_drop_down</span>
      </div>
      @if (fakeControl.hasError('required')) {
        <mat-error>Select column</mat-error>
      }
    </mat-form-field>
  }

  <mat-menu #rootMenu="matMenu" class="column-picker__menu" (closed)="setError()">
    @if (allowReset) {
      <button mat-menu-item (click)="selectColumn(null, null)">
        <div class="column-picker__menu--button">
          <span class="material-symbols-outlined">close</span>
          <span>RESET</span>
        </div>
      </button>
    }

    @for (node of treeNodes; track node.key) {
      @if (node.children && node.children.length > 0) {
        <button
          mat-menu-item
          [matMenuTriggerFor]="menu.childMenu"
          #trigger="matMenuTrigger"
          (mouseenter)="trigger.openMenu()">
          <div class="column-picker__menu--button">
            <span class="material-symbols-outlined">folder</span>
            <span>{{ node.name | uppercase }}</span>
          </div>
        </button>
        <app-column-picker-item
          #menu
          [items]="node.children"
          (selectedColumnKey)="selectColumn($event.key, $event.name)"></app-column-picker-item>
      } @else {
        <button mat-menu-item (click)="selectColumn(node.key, node.name)" [disabled]="node.disabled">
          <div class="column-picker__menu--button">
            <span class="material-symbols-outlined">add_circle</span>
            <span>{{ node.name | uppercase }}</span>
          </div>
        </button>
      }
    }
  </mat-menu>
</div>
